import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {fuseAnimations} from '@fuse/animations';
import {FuseTranslationLoaderService} from '@fuse/services/translation-loader.service';
import {saveAs} from 'file-saver';
import * as moment from 'moment';
import {WalletP2PTransaction} from '../../../../../../core/model/wallet-P2P-transaction.model';
import {BuyerService} from '../../buyer.service';
import {locale as english} from './i18n/en';
import {locale as italian} from './i18n/it';

@Component({
  selector: 'app-wallet-transaction-dialog',
  templateUrl: './wallet-transaction-dialog.component.html',
  styleUrls: ['./wallet-transaction-dialog.component.scss'],
  animations: [fuseAnimations],
  encapsulation: ViewEncapsulation.None,
})
export class WalletTransactionDialogComponent implements OnInit {
  displayedColumns = ['date', 'comment', 'invoiceId', 'type', 'amountDeb', 'amountCred'];

  walletTransactions: Array<WalletP2PTransaction>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: WalletTransactionDialogModel,
    public buyerService: BuyerService,
    private _dialogRef: MatDialogRef<WalletTransactionDialogComponent>,
    private _translationLoader: FuseTranslationLoaderService,
  ) {
    this._translationLoader.loadTranslations(italian, english);
  }

  ngOnInit(): void {
    this.walletTransactions = this.data.walletTransactions;
  }

  export(type: 'csv' | 'xls'): void {
    this.buyerService.exportWalletTransactions(this.data.fundId, type).subscribe(res => {
      const blob = new Blob([res]);
      // TODO: remove when time
      if (this.data.buyerEmail === 'nicolas.henrion@fortesecurities.com') {
        saveAs(blob, `${moment().format('YYYYMMDD')}_CAS_Movements_completo.${type}`);
        return;
      }
      saveAs(blob, `export_wallet_completo.${type}`);
    });
  }

  /*exportWalletCsv(transactionsList: Array<WalletP2PTransaction>): void {
    transactionsList.map(transaction => {
      transaction.amountDeb = null;
      transaction.amountCred = null;
      if (!this.buyerService.userSelectedFund) {
        return;
      }

      if (transaction.sender === this.buyerService.userSelectedFund.walletId) {
        transaction.amountDeb = transaction.amount;
      } else if (transaction.reciver === this.buyerService.userSelectedFund.walletId) {
        transaction.amountCred = transaction.amount;
      }
    });

    const { Parser } = require('json2csv');
    const fields = [
      { label: 'Id', value: 'id' },
      { label: 'Data e ora', value: 'date' },
      { label: 'Importo Deb (-)', value: 'amountDeb' },
      { label: 'Importo Cred (+)', value: 'amountCred' },
      { label: 'Causale', value: 'comment' },
      { label: 'ID Fattura', value: 'invoiceId' },
      { label: 'Tipo', value: 'type' },
    ];

    const transforms = [
      value => ({ ...value, date: this.datePipe.transform(value.date, 'dd/MM/yyyy hh:mm:ss') }),
    ];

    const json2csvParser = new Parser({ fields, transforms, delimiter: ';' });
    const csv = json2csvParser.parse(this.walletTransactions);

    const blob = new Blob([csv], { type: 'text/csv' });
    saveAs(blob, 'export_wallet.csv');
  }*/
}

export interface WalletTransactionDialogModel {
  walletTransactions: Array<WalletP2PTransaction>;
  fundId: number;
  buyerEmail: string;
}
